import React, { useContext, useEffect, useState } from 'react'
import classes from './ServicesChar.module.css'

import quick from "../../../../assets/HighQuality.png";
import customerservice from "../../../../assets/FreeShipping.png";
import perfect from "../../../../assets/Support.png";
import secure from "../../../../assets/WarrantyProtection.png";
import bg from "../../../../assets/ServiceBg.png";
import CharBg from "../../../../assets/CharBg.png";
import ServiceIconBg from "../../../../assets/ServiceIconBg.png";
import { useSelector } from 'react-redux';
import axios from 'axios';
import AuthContext from '../../authContext';

const ServicesChar = () => {
    const authCtx = useContext(AuthContext);
    const language = useSelector((state) => state.products.selectedLanguage[0].Language);
    const [aboutData, setaboutData] = useState({about_services: []});
  
    
        const fetchServicesData = async () => {
          try {
            const response = await axios.get(`${import.meta.env.VITE_TESTING_API}/services?ecom_type=hanoot`);
            // console.log('Response services:', response.data.data);
            setaboutData(response.data.data || [])
          } catch (error) {
            console.error('Error fetching services:', error);
          }
        };
           
        useEffect(() => {
          fetchServicesData();
        }, []);
  return (
    <div className={classes.char_container}>
        <div className={classes.char} >
                <div className={classes.contentCont}>
                <div className={classes.char_img} onClick={()=>console.log(aboutData)}>
                  <img src={aboutData?.[0]?.image? aboutData?.[0]?.image : quick} alt="" /> 
                  <img src={ServiceIconBg} alt="" style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0',objectFit:'fill'}}/>
                </div>
                    <div style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0'}}>
                      <img src={bg} alt="" style={{height:'100%',objectFit:'fill',width:'100%'}}/>
                    </div>
                    <h3>{language === 'eng' ? aboutData?.[0]?.title_en : aboutData?.[0]?.title_fr }</h3>
                    <div className={classes.border}></div>
                    <p >{language === 'eng' ? aboutData?.[0]?.description_en : aboutData?.[0]?.description_fr } </p>
                </div>
                <div className={classes.contentCont}>
                <div className={classes.char_img}>
                  <img src={aboutData?.[1]?.image? aboutData?.[1]?.image : secure} alt="" /> 
                  <img src={ServiceIconBg} alt="" style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0',objectFit:'fill'}}/>
                </div>
                    <div style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0'}}>
                      <img src={bg} alt="" style={{height:'100%',objectFit:'fill',width:'100%'}}/>
                    </div>
                    <h3>{language === 'eng' ? aboutData?.[1]?.title_en : aboutData?.[1]?.title_fr }</h3>
                    <div className={classes.border}></div>
                    <p >{language === 'eng' ? aboutData?.[1]?.description_en : aboutData?.[1]?.description_fr }</p>
                </div>
                <div className={classes.contentCont}>
                <div className={classes.char_img}>
                  <img src={aboutData?.[2]?.image? aboutData?.[2]?.image : customerservice} alt="" /> 
                  <img src={ServiceIconBg} alt="" style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0',objectFit:'fill'}}/>
                </div>
                    <div style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0'}}>
                      <img src={bg} alt="" style={{height:'100%',objectFit:'fill',width:'100%'}}/>
                    </div>
                    <h3>{language === 'eng' ? aboutData?.[2]?.title_en : aboutData?.[2]?.title_fr }</h3>
                    <div className={classes.border}></div>
                    <p >{language === 'eng' ? aboutData?.[2]?.description_en : aboutData?.[2]?.description_fr }</p>
                </div>
                <div className={classes.contentCont}>
                <div className={classes.char_img}>
                  <img src={aboutData?.[3]?.image? aboutData?.[3]?.image : perfect} alt="" /> 
                  <img src={ServiceIconBg} alt="" style={{position:'absolute',width:'100%',zIndex:'-1',bottom:'0',left:'0',height:'100%',objectFit:'fill'}}/>
                </div>
                    <div style={{position:'absolute',width:'100%',height:'100%',zIndex:'-1',bottom:'0',left:'0'}}>
                      <img src={bg} alt="" style={{height:'100%',objectFit:'fill',width:'100%'}}/>
                    </div>
                    <h3>{language === 'eng' ? aboutData?.[3]?.title_en : aboutData?.[3]?.title_fr }</h3>
                    <div className={classes.border}></div>
                    <p>{language === 'eng' ? aboutData?.[3]?.description_en : aboutData?.[3]?.description_fr }</p>
                </div>
        </div>
        <img src={CharBg} alt='' className={classes.charCont}/>
      </div>
  )
}

export default ServicesChar